<template>
<div style="display:contents">
  <!-- SIN SESIÓN: solo login, sin chrome -->
  <router-view v-if="!auth.isLoggedIn" />

  <!-- CON SESIÓN: layout completo -->
  <div v-else style="display:contents">
    <div style="display:contents">
      <div id="sb-backdrop" @click="closeMob"></div>

      <div id="sb-wrap">
        <aside id="sb">
          <div class="logo">
            <div class="logo-ico">M</div>
            <div class="logo-name hc">
              <strong>MHLM</strong>
              <small>Consultoría SaaS</small>
            </div>
          </div>

          <nav class="sb-nav">
            <div class="sec hc">Principal</div>

            <router-link v-for="item in nav" :key="item.to" :to="item.to"
                         v-slot="{ isActive, navigate }" custom>
              <div class="ni" :class="{ on: isActive }" @click="onNav(navigate)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round" v-html="item.icon"></svg>
                <span class="ni-lbl hc">{{ item.label }}</span>
                <span class="ni-tip">{{ item.label }}</span>
              </div>
            </router-link>

            <div class="sb-sp"></div>
          </nav>

          <!-- El bloque del usuario abre su menú: vista clara u oscura, y
               salir. Antes el único control era el ícono de salir, y la vista
               oscura estaba escrita en la hoja de marca sin nada que la
               encendiera. -->
          <div class="sb-foot">
            <div class="sb-usr" :class="{ 'is-open': menuUsuario }" @click.stop="menuUsuario = !menuUsuario"
                 role="button" tabindex="0" :aria-expanded="menuUsuario ? 'true' : 'false'"
                 @keydown.enter="menuUsuario = !menuUsuario" @keydown.space.prevent="menuUsuario = !menuUsuario">
              <div class="ava">{{ initials }}</div>
              <div class="hc" style="min-width:0; flex:1">
                <div class="usr-nm">{{ auth.user?.nombre || 'Usuario' }}</div>
                <div class="usr-rl">{{ auth.user?.email }}</div>
              </div>
              <svg class="usr-chev hc" width="12" height="12" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="18 15 12 9 6 15"/>
              </svg>
            </div>

            <div v-if="menuUsuario" class="usr-menu" @click.stop>
              <div class="usr-menu-lbl">Vista</div>
              <button class="usr-menu-it" :class="{ 'is-on': tema === 'claro' }" @click="ponerTema('claro')">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="4"/>
                  <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>
                </svg>
                Modo claro
                <span v-if="tema === 'claro'" class="usr-menu-tick">✓</span>
              </button>
              <button class="usr-menu-it" :class="{ 'is-on': tema === 'oscuro' }" @click="ponerTema('oscuro')">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
                </svg>
                Modo oscuro
                <span v-if="tema === 'oscuro'" class="usr-menu-tick">✓</span>
              </button>

              <div class="usr-menu-sep"></div>

              <button class="usr-menu-it is-salir" @click="doLogout">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Salir
              </button>
            </div>
          </div>
        </aside>

        <button id="col-btn" @click="toggleCol" :title="collapsed ? 'Expandir' : 'Colapsar'">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline :points="collapsed ? '9 18 15 12 9 6' : '15 18 9 12 15 6'" />
          </svg>
        </button>
      </div>

      <div id="main">
        <header id="hdr">
          <div style="display:flex;align-items:center;gap:10px;min-width:0">
            <button class="mob-btn" @click="openMob" aria-label="Abrir menú">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            </button>
            <h1>{{ currentTitle }}</h1>
            <span class="hdr-sub">{{ currentSub }}</span>
          </div>
          <div class="hdr-r">
            <span class="pill pill-b">v0.1</span>
          </div>
        </header>

        <div id="cnt">
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <MsgModal ref="msgModal" />
</div>
</template>

<script>
import { auth, clearSession } from './services/auth';
import api from './services/api';
import MsgModal from './components/MsgModal.vue';

const NAV = [
  { to: '/dashboard', label: 'Inicio',    sub: 'Resumen operativo', icon: '<path d="M3 12l9-9 9 9"/><path d="M5 10v10h14V10"/>' },
  { to: '/clientes',  label: 'Clientes',  sub: 'Clientes y proveedores', icon: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>' },
  { to: '/facturas',  label: 'Facturas',  sub: 'Ventas y cobros',   icon: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>' },
  { to: '/facturacion', label: 'Facturación', sub: 'Emisión electrónica ARCA', icon: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' },
  { to: '/cuentas',   label: 'Cuentas corrientes', sub: 'Saldos y movimientos', icon: '<rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>' },
  { to: '/gastos',    label: 'Gastos propios', sub: 'Finanzas personales', icon: '<path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/>' },
  { to: '/reportes',  label: 'Informes',  sub: 'Análisis y exportaciones', icon: '<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>' },
  // Radar COMEX: el boletín diario. Ícono de radar —círculos y barrido—,
  // que es lo que hace: barre el Boletín Oficial todas las mañanas.
  { to: '/radar',     label: 'Radar COMEX', sub: 'Boletín diario de comercio exterior', icon: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><line x1="12" y1="12" x2="19" y2="7"/>' },
  { to: '/profile',   label: 'Mi perfil', sub: 'Datos y seguridad', icon: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>' }
];

export default {
  name: 'App',
  components: { MsgModal },
  data() { return { auth, nav: NAV, collapsed: false, menuUsuario: false, tema: 'claro' }; },
  created() {
    /*
     * La vista elegida se guarda en el navegador y se aplica antes de pintar
     * nada. NO se mira la preferencia del sistema: en las propiedades de MHLM
     * la vista es una decisión, no algo que cambie solo según la hora o la
     * computadora. El panel arranca claro salvo que se haya elegido oscuro.
     */
    this.ponerTema(localStorage.getItem('mhlm:tema') === 'oscuro' ? 'oscuro' : 'claro');

    // Un clic en cualquier otro lado cierra el menú del usuario.
    this._cerrarMenu = () => { this.menuUsuario = false; };
    document.addEventListener('click', this._cerrarMenu);
    this._escMenu = (e) => { if (e.key === 'Escape') this.menuUsuario = false; };
    document.addEventListener('keydown', this._escMenu);

    // clearSession ya lo hace el listener global en services/auth.js
    this._onAuthLost = () => {
      if (this.$route?.name !== 'Login') {
        this.$router.push({ name: 'Login' }).catch(() => {});
      }
    };
    window.addEventListener('mhlm:auth-401', this._onAuthLost);
  },
  beforeUnmount() {
    window.removeEventListener('mhlm:auth-401', this._onAuthLost);
    document.removeEventListener('click', this._cerrarMenu);
    document.removeEventListener('keydown', this._escMenu);
  },
  computed: {
    currentTitle() { return this.nav.find(n => n.to === this.$route.path)?.label || 'MHLM'; },
    currentSub()   { return this.nav.find(n => n.to === this.$route.path)?.sub   || ''; },
    initials() {
      const n = this.auth.user?.nombre || this.auth.user?.email || 'U';
      return n.substring(0,2).toUpperCase();
    }
  },
  methods: {
    onNav(navigate) { this.closeMob(); navigate(); },
    toggleCol() {
      this.collapsed = !this.collapsed;
      document.body.classList.toggle('col', this.collapsed);
    },
    openMob()  { document.body.classList.remove('col'); document.body.classList.add('mob-open'); },
    closeMob() { document.body.classList.remove('mob-open'); },
    ponerTema(cual) {
      this.tema = cual === 'oscuro' ? 'oscuro' : 'claro';
      document.body.classList.toggle('dark', this.tema === 'oscuro');
      localStorage.setItem('mhlm:tema', this.tema);
      this.menuUsuario = false;
    },

    doLogout() {
      // 1) Limpiar sesión SÍNCRONO → auth.isLoggedIn pasa a false, layout cambia a LoginView
      clearSession();
      // 2) Navegar a login (guard ya deja pasar porque no hay sesión)
      this.$router.push({ name: 'Login' }).catch(() => {});
      // 3) Avisar al backend en background sin esperar ni romper si falla
      api.post('/logout').catch(() => {});
    }
  }
};
</script>
